module.exports = __webpack_public_path__ + "static/img/2.552a1e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/2.png
// module id = 5ayt
// module chunks = 0